import { Digtective } from '..';

export function removeExpiredSession(facade: Digtective, session: unknown) {
  const { storage, options } = facade ?? {};
  const { sessionName } = options ?? {};
  const expired = facade.isSessionExpired(session);
  if (expired) storage?.removeItem(sessionName);
  return facade.getSession();
}
